<template>
	<transition name="slide-fade">
		<div class="modal-container" @click="closeModal">
			<div class="modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<span>Change profile picture</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<image-upload></image-upload>
				</div>
				<div class="modal-footer"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import ImageUpload from "../users/profile/ImageUpload.vue";

export default {
	components: {
		ImageUpload
	},
	methods: {
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false
			};

			this.$store.commit("updateImageUploadModal", payload);
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<style scoped>
.modal-body {
	text-align: center;
}

img {
	border-radius: 50%;
	width: 100%;
	max-width: 270px;
	object-fit: cover;
	height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ImageUploadModal.vue